import React from 'react';
import { Monogram } from './Monogram';
export function Footer() {
  return <footer className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto pt-28 pb-20 md:pt-36 md:pb-24" data-id="element-32" data-mp="3gf94guwt048f">
      <div className="flex flex-col items-center text-center" data-id="element-33" data-mp="32nulup6t651w">
        {/* The seal — the house closes with its mark, not a second introduction */}
        <Monogram className="text-sm" rule data-id="element-34" data-mp="36q94p9ah94t6" />

        <p className="font-serif italic font-light text-ink/60 text-base md:text-lg mt-10" data-id="element-35" data-mp="3uf0phflqmkvx">
          Your Chief Executive of Health.
        </p>

        <div className="mt-12 font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-ink/40" data-id="element-36" data-mp="37o2ul235f8m">
          {'Vera Wellness Co. · By application only · Est. 2025'}
        </div>
      </div>
    </footer>;
}